import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={11} fill="none" ref={ref} {...props}>
    <g stroke="#383838">
      <path fill="#fff" d="M5.156 9.843a4.464 4.464 0 1 0 0-8.929 4.464 4.464 0 0 0 0 8.929Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.156 3.602v1.785L6.228 6.46" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconTimeClock = memo(ForwardRef);
export default IconTimeClock;
